/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { QueryExecutionResponse } from '../models/QueryExecutionResponse';
import type { QueryExportResponse } from '../models/QueryExportResponse';
import type { QueryPreviewRequest } from '../models/QueryPreviewRequest';
import type { TablePreviewRequest } from '../models/TablePreviewRequest';
import type { UUID } from '../models/UUID';
import type { ViewExportRequest } from '../models/ViewExportRequest';
import type { ViewRunRequest } from '../models/ViewRunRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class QueryResourceService {

    /**
     * Runs a provided query against the provided data source
     * @param dataSourceId
     * @param namespaceId
     * @param requestBody Query to preview against the provided data source
     * @returns QueryExecutionResponse A DataPage of the provided query
     * @throws ApiError
     */
    public static getQueryPreview(
        dataSourceId: UUID,
        namespaceId: UUID,
        requestBody: QueryPreviewRequest,
    ): CancelablePromise<QueryExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces/{namespaceId}/data-sources/{dataSourceId}/preview',
            path: {
                'dataSourceId': dataSourceId,
                'namespaceId': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error related to the user request`,
                503: `An error related to the execution of the request`,
            },
        });
    }

    /**
     * Gets a preview of a specified table in a Data Source
     * @param dataSourceId
     * @param namespaceId
     * @param requestBody Table to preview against the provided data source
     * @returns QueryExecutionResponse A DataPage of the resulting Data Source's data
     * @throws ApiError
     */
    public static getTablePreview(
        dataSourceId: UUID,
        namespaceId: UUID,
        requestBody: TablePreviewRequest,
    ): CancelablePromise<QueryExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces/{namespaceId}/data-sources/{dataSourceId}/preview-table',
            path: {
                'dataSourceId': dataSourceId,
                'namespaceId': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error related to the user request`,
            },
        });
    }

    /**
     * Runs the requested view against the provided data source
     * @param dataSourceId
     * @param namespaceId
     * @param viewId
     * @param requestBody View to export against the provided data source
     * @returns QueryExportResponse A DataPage of the provided query
     * @throws ApiError
     */
    public static exportView(
        dataSourceId: UUID,
        namespaceId: UUID,
        viewId: UUID,
        requestBody: ViewExportRequest,
    ): CancelablePromise<QueryExportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces/{namespaceId}/data-sources/{dataSourceId}/views/{viewId}/export',
            path: {
                'dataSourceId': dataSourceId,
                'namespaceId': namespaceId,
                'viewId': viewId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error related to the user request`,
            },
        });
    }

    /**
     * Runs the requested view against the provided data source
     * @param dataSourceId
     * @param namespaceId
     * @param viewId
     * @param requestBody View to run against the provided data source
     * @returns QueryExecutionResponse A DataPage of the provided query
     * @throws ApiError
     */
    public static runView(
        dataSourceId: UUID,
        namespaceId: UUID,
        viewId: UUID,
        requestBody: ViewRunRequest,
    ): CancelablePromise<QueryExecutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces/{namespaceId}/data-sources/{dataSourceId}/views/{viewId}/run',
            path: {
                'dataSourceId': dataSourceId,
                'namespaceId': namespaceId,
                'viewId': viewId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `An error related to the user request`,
                503: `An error related to the execution of the request`,
            },
        });
    }

}
